const namespaced = true;

const state = {
  definitions: null,
  files: null,
  helper: null,
  resources: null,
  style: false,
};

const getters = {
  allHelpers: (state) => {
    if (state.definitions) {
      const val = state.definitions.concat(state.files);
      return val;
    }
    return [];
  },
};

const mutations = {
  SET_DEFINITIONS(state, data) {
    state.definitions = data;
  },
  SET_FILES(state, data) {
    state.files = data;
  },
  SET_HELPER(state, helperId) {
    // Remove hash from helper id
    state.helper = helperId;
    state.style = false;
  },
  SET_HELPER_(state, payload) {
    state.helper = payload.id;
    state.style = payload.styles ? payload.styles : false;
  },
  SET_RESOURCES(state, payload) {
    state.resources = payload;
  },
};

const actions = {
  setDefinitions({ commit }, data) {
    commit("SET_DEFINITIONS", data);
  },
  setFiles({ commit }, data) {
    commit("SET_FILES", data);
  },
  setHelper({ commit }, data) {
    commit("SET_HELPER", data);
  },
  setHelper_({ commit }, data) {
    commit("SET_HELPER_", data);
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
